import { useIntl } from 'react-intl'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import { DateTime } from 'luxon'
import { toAbsoluteUrl } from '../../../../_metronic/helpers/index'
import { useState } from 'react'
import NoDataPage from '../../widgets/components/NoDataPage'
import { Link } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function RecentVisitsTable({
  data,
  contentVisited,
  getVisitLoading,
}: {
  data: any
  contentVisited?: number
  getVisitLoading: any
}) {
  const { formatMessage } = useIntl()
  const [showAllVisits, setShowAllVisits] = useState<boolean>(false)
  const BtnText = 'Add new file'
  const visibleData = showAllVisits ? data : data?.slice(0, 5)

  function getTimeDifference(date: any) {
    const minutes = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject()
          .minutes
      )
    )

    const days = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().days
      )
    )

    const hours = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().hours
      )
    )
    if (days === 0 && hours === 0) {
      return `${minutes} ${formatMessage({ id: 'min ago' })}`
    }
    if (days === 0) {
      return `${hours} ${formatMessage({ id: 'hrs ago' })}`
    } else if (days === 7) {
      return `${formatMessage({ id: '1 week ago' })}`
    } else if (days < 7) {
      return `${days} ${formatMessage({ id: 'days ago' })}`
    } else {
      return DateTime.fromISO(date).toFormat('MMM dd')
    }
  }
  return (
    <>
      <div className='recent-visits-table-wrapper bg-white '>
        <div className='recent-visits-header d-flex flex-row justify-content-between align-items-center'>
          <div className='recent-visits-header-left'>
            <h5 className='mb-0 dark_text_color'>{formatMessage({ id: 'Recent Visits' })}</h5>
            {getVisitLoading ? (
              <Skeleton
                width={200}
                height={20}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <p className='mb-0 dark_text_color'>
                {contentVisited} {formatMessage({ id: 'Contents visited recently' })}
              </p>
            )}
          </div>
          {data?.length > 5 && (
            <div className='recent-visits-header-right'>
              {!showAllVisits ? (
                <button
                  className='btn btn-bg-light w-100px  btn-color-muted btn-active-color-primary d-flex justify-content-center align-items-center dark_text_color'
                  onClick={() => setShowAllVisits(true)}
                >
                  {formatMessage({ id: 'View All' })}
                </button>
              ) : null}
            </div>
          )}
        </div>
        <div className=' table-responsive'>
          <table className='table  visits-table'>
            <thead>
              <tr className=' '>
                <th>{formatMessage({ id: 'Document' })}</th>
                <th>{formatMessage({ id: 'User' })}</th>
                <th>{formatMessage({ id: 'Company' })}</th>
                <th>{formatMessage({ id: 'Last Visited' })}</th>
                <th>{formatMessage({ id: 'Actions' })}</th>
              </tr>
            </thead>
            <tbody>
              {getVisitLoading ? (
                Array.from({ length: 5 }).map((_, index) => (
                  <tr key={index}>
                    <td colSpan={5}>
                      <Skeleton
                        height={30}
                        style={{ width: '100%' }}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </td>
                  </tr>
                ))
              ) : data?.length > 0 ? (
                console.log(data, 'data'),
                visibleData?.map((item: any, id: any) => (
                  <tr key={id}>
                    <td>
                      <div className='d-flex justify-content-start'>
                        {/* {item && item?.documentFileName?.split('.').pop() === 'pdf' && (
                          <img
                            height={25}
                            width={25}
                            alt='pdf'
                            className='me-3'
                            src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                          />
                        )}
                        {item &&
                          (item?.documentFileName?.split('.').pop() === 'docx' ||
                            item?.documentFileName?.split('.').pop() === 'doc') && (
                            <img
                              height={25}
                              width={25}
                              alt='docx'
                              className='me-3'
                              src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                            />
                          )}
                        {item &&
                          (item?.documentFileName?.split('.').pop() === 'pptx' ||
                            item?.documentFileName?.split('.').pop() === 'ppt') && (
                            <img
                              height={25}
                              width={25}
                              alt='pptx'
                              className=' me-3'
                              src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                            />
                          )}
                        {item &&
                          (item?.documentFileName?.split('.').pop() === 'jpg' ||
                            item?.documentFileName?.split('.').pop() === 'png' ||
                            item?.documentFileName?.split('.').pop() === 'jpeg') && (
                            <img
                              height={25}
                              width={25}
                              alt='blank'
                              className=' me-3'
                              src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                            />
                          )}
                        {item && item?.documentFileName?.split('.').pop() === 'xlsx' && (
                          <img
                            height={33}
                            width={33}
                            alt='blank'
                            className='pe-2'
                            src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                          />
                        )}
                        {item &&
                          !(
                            item?.documentFileName?.split('.').pop() === 'pdf' ||
                            item?.documentFileName?.split('.').pop() === 'docx' ||
                            item?.documentFileName?.split('.').pop() === 'doc' ||
                            item?.documentFileName?.split('.').pop() === 'pptx' ||
                            item?.documentFileName?.split('.').pop() === 'ppt' ||
                            item?.documentFileName?.split('.').pop() === 'jpg' ||
                            item?.documentFileName?.split('.').pop() === 'png' ||
                            item?.documentFileName?.split('.').pop() === 'jpeg' ||
                            item?.documentFileName?.split('.').pop() === 'xlsx'
                          ) && (
                            <img
                              height={24}
                              width={24}
                              alt='blank'
                              className='me-3'
                              src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                            />
                          )} */}
                        {item && item?.documentFileName && (
                          <img
                            height={25}
                            width={25}
                            alt={item?.documentFileName?.split('.').pop()}
                            className='me-3'
                            src={toAbsoluteUrl(`/media/icons/file_extensions/${item?.documentFileName?.split('.').pop()}.svg`)}
                            onError={(e) => {
                              e.currentTarget.src = toAbsoluteUrl('/media/icons/file_extensions/file.svg')
                            }}
                          />
                        )}
                        <p className='pt-1 m-0 dark_text_color'>
                          {(() => {
                            const fileName = item?.documentContentName.includes('/')
                              ? item?.documentContentName.split('/').pop()
                              : item?.documentContentName

                            return `${fileName?.substring(0, 25)}${fileName?.length > 25 ? '...' : ''
                              }`
                          })()}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <DisplayImage
                          imgName={item?.profilePicFileName}
                          width='28'
                          alt='profile'
                          fit='contain'
                          height='28'
                          className='rounded-circle me-3'
                        />
                        <p className='m-0 dark_text_color'>
                          {item.userFirstName} {item.userLastName}
                        </p>
                      </div>
                    </td>
                    <td>
                      <p className='m-0 dark_text_color'>{item?.company || '-'}</p>
                    </td>
                    <td>
                      <p className='m-0 dark_text_color'>
                        {getTimeDifference(item?.lastVisited) || '-'}
                      </p>
                    </td>
                    <td>
                      <Link
                        to={`/data-rooms/file-view/main-file-view/main-file-activity-view/${item.contentId}`}
                        className='btn btn-bg-light btn-color-muted btn-active-color-primary btn-sm view-visit-button d-flex justify-content-center align-items-center border border-1 custom-button-property'
                      >
                        <p className='m-0 dark_text_color'>{formatMessage({ id: 'View' })}</p>
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>
                    <div>
                      <NoDataPage showBtn={true} BtnText={BtnText} width={`w-0`} />
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default RecentVisitsTable
